import Dbm from "dbm";
import Website from "../../../index.js";

export default class LifeDisplay extends Dbm.core.BaseObject {
    _construct() {
        super._construct();

        let container = new PIXI.Container();
        this.item.setValue("pixiLayer", container);
        
        let scaleLayer = new PIXI.Container();
        this.item.setValue("scaleLayer", scaleLayer);
        container.addChild(scaleLayer);

        let texture = Website.game.getTextures("objects/heart", "main")[0]
        let sprite = new PIXI.Sprite(texture);
        sprite.anchor.set(0.5, 0.5);
        scaleLayer.position.set(0.5*texture.width, 0.5*texture.height);

        scaleLayer.addChild(sprite);

        this.item.setValue("activeEnvelope", 0);
    }

    update(aTime, aDelta) {
        //console.log("update");

        let activeEnvelope = this.item.activeEnvelope;
        let scale = (1-activeEnvelope)*0.5+(activeEnvelope)*1;

        this.item.scaleLayer.alpha = Math.min(1, (1-activeEnvelope)*0.5+(activeEnvelope)*1);
        this.item.scaleLayer.scale.set(scale);
    }

    makeActive() {
        this.item.properties.activeEnvelope.animateValue(1.2, 0.2);
        this.item.properties.activeEnvelope.addAddionalAnimation(1.2, 1, 0.1, 0.2);
    }

    makeInactive() {
        this.item.properties.activeEnvelope.animateValue(0, 0.2);
    }

    startAnimation(aDelay) {
        this.item.properties.activeEnvelope.animateValue(1, 0.2, aDelay);
    }
}